//# sourceMappingURL=/s/files/1/0591/8641/3646/t/32/assets/custom.js.map?v=1726747452

(function () {
  var MINI_CART_OPEN_CLASS = 'is-mini-cart-open';
  var MINI_CART_ID = 'mini-cart';

  function syncMiniCartOpenClass() {
    var miniCart = document.getElementById(MINI_CART_ID);
    document.documentElement.classList.toggle(
      MINI_CART_OPEN_CLASS,
      !!(miniCart && miniCart.hasAttribute('open'))
    );
  }

  function onOpenableElementEvent(event) {
    var target = event.target;
    if (!target || target.id !== MINI_CART_ID) return;
    syncMiniCartOpenClass();
  }

  document.addEventListener('openable-element:open', onOpenableElementEvent, true);
  document.addEventListener('openable-element:close', onOpenableElementEvent, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMiniCartOpenClass);
  } else {
    syncMiniCartOpenClass();
  }
})();